import { entityStore } from '~/utility/BinSentry-ui-utility';
import { LitEntity, html, css } from '../../utility/lit-entity';
import '../../work-orders/actions/request-service-button';
import '../../work-orders/actions/request-removal-button';
import './bin-work-order-list';

class BinWorkOrderListView extends LitEntity {
  static get styles() {
    return css`
      :host {
        display: flex;
        align-items: flex-end;
        flex-direction: column;
      }
      bin-work-order-list {
        width: 100%;
      }
      .actions {
        margin: 8px;
      }
    `;
  }

  render() {
    return html`
      <div class="actions">
        <request-service-button .href="${this.workOrdersHref}" @response="${this._reload}" hide-when-unavailable></request-service-button>
        <request-removal-button .href="${this.workOrdersHref}" @response="${this._reload}" hide-when-unavailable></request-removal-button>
      </div>
      <bin-work-order-list .href="${this.workOrdersHref}"></bin-work-order-list>
    `;
  }

  _reload() {
    entityStore.invalidateHref(this.workOrdersHref);
  }

  _entityChanged(entity) {
    super._entityChanged(entity);
    this.deviceHref = this.getHref('https://api.binsentry.com/rel/device');
    this.workOrdersHref = this.getHref('https://api.binsentry.com/rel/work-orders');
  }
}

window.customElements.define('bin-work-order-list-view', BinWorkOrderListView);
